// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTopButton_button__D073z","visible":"ScrollToTopButton_visible__5QnGU","icon":"ScrollToTopButton_icon__8Dgqc"};